import { useEffect, useState } from "react";
import AADRoleEnum from "../../enum/AADRoleEnum";
import AdminEnum from "../../enum/AdminEnum";
import PageEnum from "../../enum/PageEnum";
import { screenNameActions } from "../../store/screen/ScreenNameSlice";
import { useAppDispatch } from "../../store/StoreHooks";
import { ADMIN_TABS } from "../../utils/admin/AdminConstants";
import { AuthZ } from "../common/auth/AuthZ";
import { AmdTabs } from "../common/tabs/tabs";
import { Airports } from "./airports/Airports";
import { Organizations } from "./organizations/Organizations";
import { Roles } from "./roles/Roles";
import { Users } from "./users/Users";

export const AdminContainer: React.FC<{ airport: string }> = ({ airport }) => {
  const dispatch = useAppDispatch();
  const [selectedTab, setSelectedTab] = useState<string>(AdminEnum.Tabs.Users);

  useEffect(() => {
    dispatch(screenNameActions.setScreenName(PageEnum.BreadcrumbEnum.Admin));
  }, [dispatch]);

  const roles = [AADRoleEnum.Admin];
  const onTabSelect = (tab: string) => setSelectedTab(tab);

  return (
    <AuthZ roles={roles} airportCode={airport}>
      <>
        <h1 className="amd-heading1">User Access Control</h1>
        <section
          className="amd-section-shadow my-4"
          data-testid="adminContainer"
        >
          <AmdTabs
            defaultSelectedTab={AdminEnum.Tabs.Users}
            tabList={ADMIN_TABS.data}
            dataTestId="admincontainer-tabs"
            onTabClick={onTabSelect}
            selectedTab={selectedTab}
          />

          {selectedTab === AdminEnum.Tabs.Users && <Users airport={airport} />}
          {selectedTab === AdminEnum.Tabs.Organizations && (
            <Organizations airport={airport} />
          )}
          {selectedTab === AdminEnum.Tabs.Roles && <Roles airport={airport} />}
          {selectedTab === AdminEnum.Tabs.Airports && <Airports />}
        </section>
      </>
    </AuthZ>
  );
};
